import { clientEnv } from "@/lib/env.client";

const productionApiHostname = "dc-two-api.documentcrunch.com";

// We discriminate dev vs. prod by inspecting `NEXT_PUBLIC_API_URL` (already
// injected per environment) — only the literal prod host gets the prod origin, so
// staging, feature/preview branches and localhost all fall through to the dev URL.
export function getDcOneOrigin(): string {
  const apiUrl = clientEnv().NEXT_PUBLIC_API_URL;

  let isProduction = false;
  try {
    isProduction = new URL(apiUrl).hostname === productionApiHostname;
  } catch {
    isProduction = false;
  }

  return isProduction ? "https://app.documentcrunch.com" : "https://app.ml.documentcrunch.com";
}

// TODO: replace this with an in-app /archive route once 2.0 has its own
// archive functionality. Until then "Go to the old platform" links back
// to the DC 1.0 dashboard so users can still reach archived content.
export function getDcOneArchiveUrl(): string {
  return `${getDcOneOrigin()}/dash?sort=createdAt&sortDirection=desc`;
}
